import { NavigationSubItem } from "../navigation-item"

export class CreateManualClV2LiquiditySubItem extends NavigationSubItem {
  readonly id = "create-manual-cl-v2"
  readonly label = "Create"
  readonly href = "/liquidity/cl/v2/create"
  readonly iconName = "manual-icon"
  readonly isExternal = false
  readonly tabs = []
}
